import BSN from 'bootstrap.native/dist/bootstrap-native-v4-esm.min.js'

const supportsDOMParser = () => {
	if (!window.DOMParser) { return false }

  const parser = new DOMParser()

  try {
		parser.parseFromString('x', 'text/html')
	} catch(err) {
		return false
	}
	return true
}

/**
 * Convert a template string into HTML DOM nodes
 * @param  {String} str The template string
 * @return {Node}       The template HTML
 */
const stringToHTML = (str) => {
	// If DOMParser is supported, use it
	if (supportsDOMParser()) {
		var parser = new DOMParser()
		var doc = parser.parseFromString(str, 'text/html')
		// The created content is encapsuled in a <body> tag.
		return doc.body.firstChild
	}

	// Otherwise, fallback to old-school method
	var dom = document.createElement('div')
	dom.innerHTML = str
	return dom
}

const createOrFindToastContainer = () => {
  let toastContainer = document.querySelector('.toast-container')
  if (toastContainer) { return toastContainer }

  toastContainer = document.querySelector('body').appendChild(stringToHTML('<div class="toast-container"></div>'))
  return toastContainer
}

// createToast()
export default function(toastHTML) {
  const toastContainer = createOrFindToastContainer()
  const toastNode = stringToHTML(toastHTML)
  const toastId = toastNode.querySelector('button.btn-close').id

  toastContainer.appendChild(toastNode)
  return new BSN.Toast(`#${toastId}`, { delay: 5000 })
}
